import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { Grid } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import axios from "axios";
import BASE_URL from "../../../constants/baseUrls";
import { IS_MOBILE } from "../../../constants/breakpoints";
import { useTranslation } from "react-i18next";
import useUserInfo from "../../../hooks/useUserInfo";
import { LocaleContext } from "../../../routing/LangRouter";
import { navigateToLoginPage } from "../../../utils/utility";

//import view components
import UserInformation from "../../../components/view/user-panel/user-account/user-information";
import PersonalInformation from "../../../components/view/user-panel/user-account/personal-information";
import BankAccountInformation from "../../../components/view/user-panel/user-account/bank-account-information";
import BaseTabs from "../../../components/common/base-tabs/base-tabs";

function UserAccount() {
    //general variables
    const location = useLocation();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams(); // Add this line
    const { locale } = useContext(LocaleContext);
    const accessToken = localStorage.getItem("accessToken");
    const { t } = useTranslation();

    //handle unauthorized error (401 status)
    const handleUnauthorizedError = () => {
        localStorage.clear();
        navigateToLoginPage(navigate, locale, location);
    };

    //request to get user information
    const { userInformation, getUserInfo } = useUserInfo();

    useEffect(() => {
        if (!accessToken) return;
        getUserInfo();
    }, [location.pathname]);

    // Create a new FormData instance to hold the file
    const createFormData = file => {
        const formData = new FormData();
        formData.append("avatar", file);
        return formData;
    };

    //request to update the user's profile image
    const [profileError, setProfileError] = useState(false);
    const submitProfileImage = async file => {
        setProfileError(false);
        const formData = createFormData(file);
        try {
            await axios.patch(`${BASE_URL}/api/v2/account/user/info/`, formData, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
        } catch (error) {
            setProfileError(true);
            if (error.response?.status === 401) {
                handleUnauthorizedError();
            } else {
                toast.error(t("Toast Messages.Image Size Limit Exceeded"), { toastId: "custom-id-yes" });
            }
        }
    };

    //handle tab change - UPDATED
    const [activeTab, setActiveTab] = useState({ personalInformation: true, bankAccountInformation: false });
    
    // Check for tab parameter on component mount - ADD THIS
    useEffect(() => {
        const tabParam = searchParams.get('tab');
        if (tabParam === 'bankAccountInformation') {
            setActiveTab({ personalInformation: false, bankAccountInformation: true });
        }
    }, [searchParams]);
    
    const handleTabChange = type => {
        setActiveTab({ [type]: true });
    };

    //list of tabs
    const tabList = [
        { type: "personalInformation", title: t("personalInfo"), activeTab: activeTab.personalInformation },
        { type: "bankAccountInformation", title: t("bankAccountInformation"), activeTab: activeTab.bankAccountInformation },
    ];

    return (
        <>
            {IS_MOBILE ? (
                <>
                    <BaseTabs handleTabChange={handleTabChange} list={tabList} style={{ top: "3rem" }} />
                    <Grid className="user-account" container item xs={12} mt={2} mb={5}>
                        {activeTab.personalInformation ? (
                            <PersonalInformation userInformation={userInformation} />
                        ) : activeTab.bankAccountInformation ? (
                            <BankAccountInformation />
                        ) : null}
                    </Grid>
                </>
            ) : (
                <Grid className="user-account" container item xs={12} rowGap={5} mb={5}>
                    <UserInformation information={userInformation} onSubmitImage={submitProfileImage} profileError={profileError} />
                    <PersonalInformation userInformation={userInformation} />
                    <BankAccountInformation />
                </Grid>
            )}
        </>
    );
}

export default UserAccount;